require('./template.js');

PegasusTemplate.EmailTemplate = PegasusTemplate.Template.extend({
  fragments: [],
  globalSettings: DS.attr('string'),
  html: DS.attr('string'),
  openingHtmlPart: DS.attr('string'),
  userDefinedBackgroundImage: null,
  userDefinedBackgroundColor: null,
  paletteType: 'Palette',
  bodyImageType: 'BodyImage',
  supportsRowColorOpacity: false,
  previewContent: function(_,value){
    if( typeof( value ) !== 'undefined' ){
      return value;
    }
    return '';
  }.property(),
  rowClass: function(){
    return PegasusTemplate.RegionView;
  },
  gallerySizeKey: 'large',
  insideHtmlPart: DS.attr('string'),
  uid: DS.attr('string'),
  maxImageWidth: 620,
  maxContentWidth: 620,
  contentRoot: function(){
    return PegasusTemplate.canvasInstance.get('childViews.firstObject.tableContent');
  },
  globalManipulationClass: function(){
    return PegasusTemplate.RegionView;
  }.property(),
  backup: function(){
    var rootElement = this.contentRoot();
    return rootElement.get('childViews.firstObject').mutateForOut(null, true).editor_cookie;
  }
});

PegasusTemplate.EmailTemplate.FIXTURES = [];

(function(){

  // Throw from here if not
  function guaranteeSendableProduct(messageBodyContent){
    // If the content doesn't contain more than one
    // table it is not viable.  messageContent is the top level table
    // and its child tables.
    //
    // Make sure, if the wheels do come off, that the content remains
    // at the last known good state.
    if ( ! $( messageBodyContent ).find('table').length ) {
      throw new Error("Nothing worth outputting");
    }
  }

  function resetBodyBackground(template){
    var doc = document.createElement('html');
    doc.innerHTML = template;
    $(doc).find('body').removeAttr('data-vr-default-background-image-override');
    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function extractHtmlChunks(template){
    var positionOfBodyClosing = template.search(/<\/body>/),
      positionOfBodyOpening = template.search(/<body/),
      positionInsideOfBody;

    if (positionOfBodyOpening === -1 || positionOfBodyClosing === -1) {
      throw new Error('Error processing message template, expected a body element.');
    }
    // move split postition to inside of body element
    positionInsideOfBody = template.slice(positionOfBodyOpening);
    positionInsideOfBody = positionInsideOfBody.search(/>/) + positionOfBodyOpening + 1;

    return {
      // preserve opening html, head and body (with any attributes, e.g. style) elements
      openingHtmlHeadBody: template.slice(0, positionInsideOfBody),
      // encapsulate what is changing... the body element's innerHTML
      insideBody: template.slice(positionInsideOfBody, positionOfBodyClosing),
      // preserve closing body and html elements
      closingBodyHTML: template.slice(positionOfBodyClosing)
    };
  }

  function withDefault(value, defaultValue) {
    if (value && value.length > 0) {
      return value;
    }
    return defaultValue;
  }

  function extractDefaults(template){
    var doc = document.createElement('html'),
      result;

    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */

    var data = doc.getElementsByTagName('body')[0].dataset;

    var defaultBackgroundColor = data.vrDefaultBackgroundColor || '#C1C1C1',
      defaultViewOnlineEnabled = data.vrViewOnlineEnabled,
      userSelectedPrimaryColor = data.vrThemePrimaryColorOverride,
      userSelectedSecondaryColor = data.vrThemeSecondaryColorOverride,
      defaultBackgroundImage = data.vrDefaultBackgroundImageOverride || data.vrDefaultBackgroundImage || '',
      defaultFontFace = data.vrDefaultFontFace || '',
      defaultThemeColor = data.vrDefaultThemeColor || '#F1F1F1',
      templateThemeName = data.vrDefaultThemeName,
      ogpTitle = data.vrOgpTitle,
      ogpDescription = data.vrOgpDescription,
      ogpImage = data.vrOgpImage;

    var toolbarController = PegasusTemplate.lookupController('toolbar');

    if ( userSelectedPrimaryColor ) {
      toolbarController.set('selectedPrimaryColor', userSelectedPrimaryColor);
    }

    if ( userSelectedSecondaryColor ) {
      toolbarController.set('selectedSecondaryColor', userSelectedSecondaryColor);
    }

    var theme = {
      name: templateThemeName
    };

    function logoEnabled(){
      if ( PegasusTemplate.get('options.isWhiteLabeled') ) { return false; }
      // if they've downgraded or have never upgraded
      if ( !toolbarController.get('isAuthorizedToRemoveLogo') ) { return 'true'; }
      // if it hasn't yet been defined
      if ( typeof( data.vrFooterLogoEnabled ) === 'undefined' ) {
        return toolbarController.get('userLevelLogoHidden') ? '' : 'true';
      }
      // else if it's already been defined
      return data.vrFooterLogoEnabled;
    }

    result = {
      isFooterLogoEnabled: logoEnabled(),
      isFooterEmailPreferencesEnabled: data.vrFooterEmailPreferencesEnabled === 'true' ? true : '',
      footerLabelOpen: withDefault(data.vrFooterLabelOpen, Em.I18n.t('footer.label_open')),
      footerLabelJoin: withDefault(data.vrFooterLabelJoin, Em.I18n.t('footer.label_join')),
      footerLabelClose: withDefault(data.vrFooterLabelClose, Em.I18n.t('footer.label_close')),
      footerLabelColor: data.vrFooterLabelColor  || '#0000FF',
      footerAnchorColor: data.vrFooterAnchorColor  || '#0000FF',
      footerLabelSize: data.vrFooterLabelSize || '12',
      footerLabelAlignment: data.vrFooterLabelAlignment || 'center',
      footerLabelBold: data.vrFooterLabelBold || 'false',
      footerLabelItalic: data.vrFooterLabelItalic || 'false',

      ogpTitle: ogpTitle || '',
      ogpDescription: ogpDescription || '',
      ogpImage: ogpImage || '',

      isViewOnlineEnabled: defaultViewOnlineEnabled,
      viewOnlineLabelColor: data.vrViewOnlineLabelColor || '#000000',
      viewOnlineLabelSize: data.vrViewOnlineLabelSize || '12',
      viewOnlineLabelAlignment: data.vrViewOnlineLabelAlignment || 'center',
      viewOnlineLabel: data.vrViewOnlineLabel || Em.I18n.t("instructions.view_email_in_browser"),
      viewOnlineLabelBold: data.vrViewOnlineLabelBold || 'false',
      viewOnlineLabelItalic: data.vrViewOnlineLabelItalic || 'false',
      selectedIsAnimatedGif: data.vrIsBackgroundAnimatedGif || 'false',

      defaultBackgroundImage: defaultBackgroundImage,
      defaultBackgroundColor: defaultBackgroundColor,
      defaultFontFace: defaultFontFace,
      defaultThemeColor: defaultThemeColor,
      selectedBackgroundImage: defaultBackgroundImage,
      selectedBackgroundColor: data.vrDefaultBackgroundColorOverride || defaultBackgroundColor,
      selectedFontFace: data.vrDefaultFontFaceOverride || defaultFontFace,
      selectedRowColor: data.vrDefaultThemeColorOverride || defaultThemeColor,
      selectedTheme: theme,
      selectedBorderWidth: data.vrDefaultBorderThickness,
      selectedBorderRadius: data.vrDefaultBorderRadius,
      selectedBorderColor: data.vrDefaultBorderColor,
      selectedShadowSpreadRadius: data.vrDefaultShadowWidth,
      selectedShadowBlurRadius: data.vrDefaultShadowBlur
    };

    return result;
  }

  function extractGlobalSettings(template) {
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    return doc.getElementsByTagName('body')[0].dataset.vrGlobalSettings || null;
  }

  function addBodyData(template){
    var doc = document.createElement('html'),
      controller = PegasusTemplate.lookupController('toolbar');

    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    $(doc).find('body').
      attr({
        'data-vr-footer-email-preferences-enabled': controller.get('isFooterEmailPreferencesEnabled') ? "true" : '',
        'data-vr-footer-label-open': controller.get('footerLabelOpen').escapeHTML(),
        'data-vr-footer-label-join': controller.get('footerLabelJoin').escapeHTML(),
        'data-vr-footer-label-close': controller.get('footerLabelClose').escapeHTML(),
        'data-vr-footer-logo-enabled': controller.get('isFooterLogoEnabled') ? "true" : '',
        'data-vr-footer-label-color': controller.get('footerLabelColor'),
        'data-vr-footer-anchor-color': controller.get('footerAnchorColor'),
        'data-vr-footer-label-size': controller.get('footerLabelSize'),
        'data-vr-footer-label-alignment': controller.get('footerLabelAlignment'),
        'data-vr-footer-label-bold': controller.get('footerLabelBold'),
        'data-vr-footer-label-italic': controller.get('footerLabelItalic'),
        'data-vr-is-background-animated-gif': controller.get('selectedIsAnimatedGif'),
        'data-vr-view-online-label': controller.get('viewOnlineLabel').escapeHTML(),
        'data-vr-view-online-label-bold': controller.get('viewOnlineLabelBold'),
        'data-vr-view-online-label-italic': controller.get('viewOnlineLabelItalic'),
        'data-vr-view-online-label-color': controller.get('viewOnlineLabelColor'),
        'data-vr-view-online-label-alignment': controller.get('viewOnlineLabelAlignment'),
        'data-vr-view-online-label-size': controller.get('viewOnlineLabelSize'),
        'data-vr-view-online-enabled': controller.get('isViewOnlineEnabled') ? "true" : '',
        'data-vr-theme-primary-color-override': controller.get('selectedPrimaryColor'),
        'data-vr-theme-secondary-color-override': controller.get('selectedSecondaryColor'),
        'data-vr-default-background-image-override': controller.get('selectedBackgroundImage'),
        'data-vr-default-background-color-override': controller.get('selectedBackgroundColor'),
        'data-vr-default-font-face-override': controller.get('selectedFontFace'),
        'data-vr-default-theme-color-override': controller.get('selectedRowColor'),
        'data-vr-default-theme-name': controller.get('selectedTheme.name'),
        'data-vr-default-shadow-width': controller.get('selectedShadowSpreadRadius'),
        'data-vr-default-shadow-blur': controller.get('selectedShadowBlurRadius'),
        'data-vr-default-border-radius': controller.get('selectedBorderRadius'),
        'data-vr-default-border-color': controller.get('selectedBorderColor'),
        'data-vr-default-border-thickness': controller.get('selectedBorderWidth'),
        'data-vr-ogp-title': controller.get('ogpTitle'),
        'data-vr-ogp-description': controller.get('ogpDescription'),
        'data-vr-ogp-image': controller.get('ogpImage')
      });

    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function addBodyStyles(template){
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    $(doc).find('body').css( 'font-family', PegasusTemplate.lookupController('toolbar').get('selectedFontFace') );
    //ensure ckeditor does not hijack body and make position relative.
    //https://jira.verticalresponse.com/browse/VR2-20827
    $(doc).find('body').css( 'position', 'static' );
    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function generateQuery(arr){
    return arr.reduce(function(accum, item){
      accum[item.inflection_point] = accum[item.inflection_point] || [];
      accum[item.inflection_point].push( {
        className: item.class_name,
        style: item.style,
        propertyName: item.property_name
      } );
      return accum;
    }, {});
  }

  function addOGPMeta(message, data){
    var $meta = $('<meta>');
    var controller = PegasusTemplate.lookupController('toolbar');
    var ogpTitle, ogpDescription, twitterCard, ogpImage, data = {
      title: controller.get('ogpTitle'),
      description: controller.get('ogpDescription'),
      image: controller.get('ogpImage')
    };
    var titleElement = $('<title>').html(data.title||'Email')[0].outerHTML;

    $meta.attr('property', 'og:title').attr('content', data.title);
    ogpTitle = $meta[0].outerHTML;
    $meta.attr('property', 'og:description').attr('content', data.description);
    ogpDescription = $meta[0].outerHTML;
    $meta.attr('property', 'twitter:card').attr('content', 'summary_large_image');
    twitterCard = $meta[0].outerHTML;
    $meta.attr('property', 'og:image').attr('content', data.image).attr('data-background-image', data.image);
    ogpImage = $meta[0].outerHTML;

    return message.replace(
      '<head>',
      ['<head>', titleElement, ogpTitle, ogpDescription, ogpImage, twitterCard].join('')
    );
  }

  function addMediaQueries(template){
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    var head = $(doc).find('head');
    var styles = $('<style type="text/css">');
    styles.insertAfter(head.find('style').first());

    var rowNames = $(doc).find('body').find('.vr-row').map(function(i,x){ return $(x).attr('name'); });

    rowNames.toArray().forEach(function(name){
      var block = PegasusTemplate.lookupStore().all(PegasusTemplate.Block).filterProperty('name', name).get('firstObject');
      var queries = [];
      queries.push( generateQuery( PegasusTemplate.Block.global_queries ) );
      if ( block.get('media_queries') ){
        queries.push( generateQuery( block.get('media_queries') ) );
      }
      queries.forEach(function(q){
        var queryRule = '',
          opening = '{',
          closing = '}',
          selector;

        Object.keys( q ).forEach(function(inflection){
          var rules = q[inflection],
            selectorParts,
            isQuotedClass,
            quoteEnd;

          rules.forEach(function(rule){
            isQuotedClass = rule.className.indexOf('"') === 0;

            if ( isQuotedClass ) {
              quoteEnd = rule.className.lastIndexOf('"') + 1;

              selectorParts = [
                rule.className.slice(0, quoteEnd),
                rule.className.slice(quoteEnd)
              ];
            } else {
              selectorParts = rule.className.split(' ');
            }

            selector = 'body[yahoo] [name="'+name+'"] [class='+ selectorParts[0] +'] ' + selectorParts.slice(1).join(' ');
            queryRule = queryRule + "@media only screen and (" + rule.propertyName +':'+ inflection +') {' + selector + ' {';
            queryRule = queryRule + rule.style + closing + closing;
          });

          styles.html( styles.html() + queryRule );
        });
      });
    });

    // NOTE the lack of the 'g' qualifier
    // we insertAfter the first style so we can safely assume the textual
    // representation of that heirarchy could be conjoined with the following.
    //
    // Why?  Zimbra treats all elements past the first style element (not includeing the one it
    // inserts) as text and breaks the preview snippet by inserting style definitions.
    return "<!DOCTYPE html>" + doc.outerHTML.replace(/<\/style><style type="text\/css">/,'');
  }

  var whitelistedDataAttributes = [
    'data-vr-structure-canvas',
    'data-vr-structure-cell',
    'data-vr-structure-row',
    'data-background-image'
  ];

  // leave the structure data- attributes as they are used for some responsive behavior.
  // TODO: add classes to structure elements so that we don't rely on data- attributes for
  // rendering.
  function removeUnneededMessageArtifacts(html){
    var doc = document.createElement('html');
    doc.innerHTML = html;
    var $el, dashed;
    $(doc).find('script').remove();
    $(doc).find('*').each(function(i, element){
      $el = $(element);
      $el.removeAttr('draggable');
      $el.removeAttr('contenteditable');
      $.each(element.dataset, function (i) {
        dashed = 'data-' + i.dasherize();
        if ( whitelistedDataAttributes.indexOf(dashed) === -1 ) {
          $el.removeAttr(dashed);
        }
      });
    });

    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  PegasusTemplate.EmailTemplate.reopen({
    assembleStructured: function(templateHTML){
      var base = templateHTML,
        globalSettings = extractGlobalSettings(base),
        defaults = extractDefaults(base),
        product = null,
        chunks,
        mutation = function(){
          return chunks.openingHtmlHeadBody.slice( chunks.openingHtmlHeadBody.search(/<body/) ) + /* don't include the head in the editor interface */
            '<div class="vr-view-online-block-spacer"></div>' +
            '{{view PegasusTemplate.ViewOnlineShowView}}' +
            '{{view PegasusTemplate.CanvasInstanceCanvasView}}' +
            '{{#unless PegasusTemplate.blockRegionInstance.length}}{{view PegasusTemplate.NoRowsView}}{{/unless}}' +
            '{{#if PegasusTemplate.options.includesFooter}}{{view PegasusTemplate.FooterShowView}}{{/if}}' +
            chunks.closingBodyHTML;
        }.bind(this);

      base = resetBodyBackground( base );
      chunks = extractHtmlChunks(base || "<html><head></head><body></body></html>"),

      Em.set(PegasusTemplate, 'defaults', defaults);

      // Clear the existing value as the app exists as a single render
      // entity.
      PegasusTemplate.lookupController('toolbar').set( 'selectedTheme', null );
      PegasusTemplate.lookupController('toolbar').setProperties(
        defaults
      );

      return this.store.createRecord(PegasusTemplate.EmailTemplate, {
        html: mutation(),
        globalSettings: chunks.globalSettings || '',
        openingHtmlPart: chunks.openingHtmlHeadBody,
        insideHtmlPart: chunks.insideBody,
        closingHtmlPart: chunks.closingBodyHTML
      });
    },

    createFromExternal: function(){
      var assetHostInterpolatedTemplate = PegasusTemplate.get('options.template').
          replace(/{SERVER_URL}/g, PegasusTemplate.get('templateAssetHost')).
          replace("body[yahoo] > table[data-vr-structure-canvas]", "body[yahoo] [data-vr-structure-canvas]").
          replace("body[yahoo] td[data-vr-structure-cell]", "body[yahoo] [data-vr-structure-cell]"),
        data = {
            id: 1,
            editor_cookie: assetHostInterpolatedTemplate
          },
        message = assetHostInterpolatedTemplate,
        structured = this.assembleStructured( message );
        data = $.extend(data,
          PegasusTemplate.get('options.social_follow'));

      return {
        data: data,
        model: structured
      };
    },

    generateOutput: function(forSending) {
      var openingHtml = PegasusTemplate.loadedTemplate().get('openingHtmlPart'),
        closingHtml = PegasusTemplate.loadedTemplate().get('closingHtmlPart'),
        canvas = PegasusTemplate.canvasInstance.mutateForOut(true),
        messageContent = canvas.message,
        socialFollowData = $.extend( PegasusTemplate.lookupController('socialFollow').get('content'), {}),
        previewSnippet = [
          '<div id="vr_preview_snippet" style="display:none;height:0;width:0;opacity:0;overflow:hidden;min-height:0;max-height:0;min-width:0;max-width:0;">',
          '{VR_PREVIEW_SNIPPET}',
          '</div>'
        ].join(''),
        fontFixForMSO = '<!--[if gte mso 9]><div style="display:none;">{VR_MSO_FONT_OVERRIDE}</div><![endif]-->';
      // can throw
      guaranteeSendableProduct( messageContent );

      // We'll refuse to pass back information that we, autonomously, know is invalid
      var base = addBodyStyles( openingHtml + previewSnippet + fontFixForMSO + messageContent + closingHtml );
      var editorStateCookieVersionOfTheMessage = openingHtml + canvas.editor_cookie + closingHtml;
      editorStateCookieVersionOfTheMessage = addBodyData( editorStateCookieVersionOfTheMessage );
      var images = [];
      var sendableMessage = '';
      var toolbarController = PegasusTemplate.lookupController('toolbar');

      if ( forSending ) {
        sendableMessage = addMediaQueries( base );
        sendableMessage = addOGPMeta( sendableMessage );

        function generateParsable(message) {
          var doc = document.implementation.createHTMLDocument(""),
            doc_elt = doc.documentElement,
            first_elt;

          doc_elt.innerHTML = message;

          return $(doc_elt);
        }

        var elements = generateParsable(editorStateCookieVersionOfTheMessage).find('[data-src], [data-background-image], [data-vr-default-background-image-override], [data-vr-default-background-image]');
        elements = elements.add(generateParsable(sendableMessage).find('[data-src], [data-background-image], [data-vr-default-background-image-override], [data-vr-default-background-image]') );

        var data;
        var $x;
        var elementData;

        if ( toolbarController.get('ogpImage') ) {
          images.push({
            file: toolbarController.get('ogpImage')
          });
        }

        elements.each(function(i,x){
          $x = $(x);
          elementData = x.dataset;
          var src = elementData.vrDefaultBackgroundImageOverride || elementData.backgroundImage || elementData.src;
          if ( !src ) { return; }

          data = {
            file: src,
            name: $x.attr('data-name'),
            alt: $x.attr('data-alt')
          };

          images.push( data );
        });

        sendableMessage = removeUnneededMessageArtifacts( sendableMessage );
      }


      var result = {
        // message data
        message: sendableMessage,
        editor_cookie: editorStateCookieVersionOfTheMessage,

        images: images,

        street_address: toolbarController.get('footerStreetAddress'),
        extended_address: toolbarController.get('footerExtendedAddress'),
        company: toolbarController.get('footerCompany'),
        postal_code: toolbarController.get('footerPostalCode'),
        country: toolbarController.get('footerCountry'),
        phone: toolbarController.get('footerPhone'),
        locality: toolbarController.get('footerLocality'),
        region: toolbarController.get('footerRegion'),

        // social follow urls
        pinterest_url: socialFollowData.pinterest_url,
        facebook_url: socialFollowData.facebook_url,
        twitter_url: socialFollowData.twitter_url,
        google_url: socialFollowData.google_url,
        youtube_url: socialFollowData.youtube_url,
        linkedin_url: socialFollowData.linkedin_url,
        instagram_url: socialFollowData.instagram_url,
        snapchat_url: socialFollowData.snapchat_url,
        tumblr_url: socialFollowData.tumblr_url
      };

      if ( toolbarController.get('didToggleFooterLogo') ) {
        result.did_toggle_footer_logo = true;
        result.hide_implementor_logo = !toolbarController.get('isFooterLogoEnabled');
      }

      return result;
    }
  });
})();
